
// import React, { useState, useEffect } from 'react';
// import {
//   Box,
//   Typography,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   IconButton,
//   Pagination,
//   TextField,
// } from '@mui/material';
// import { styled } from '@mui/material/styles';
// import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
// import axios from 'axios';
// import { Button } from '@mui/material';


// const StyledTableCell = styled(TableCell)({
//   padding: '16px',
//   fontSize: '0.875rem',
// });

// const ITEMS_PER_PAGE = 5;

// const MyInvestments= () => {
//   const [activeToggle, setActiveToggle] = useState('Group');
//   const [page, setPage] = useState(1);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [data, setData] = useState([]);

//   useEffect(() => {
//     fetchFundedParticipants();
//   }, [activeToggle]);

//   const fetchFundedParticipants = async () => {
//     try {
//       const endpoint =
//         activeToggle === 'Single'
//           ? 'https://puneexpobackend.tdtlworld.com/api/all_single_participants/'
//           : 'https://puneexpobackend.tdtlworld.com/api/all_group_participants/';

//       const response = await axios.get(endpoint);

//       const fundedData = response.data.data
//         .filter((item) => item.idea_submission?.status?.toLowerCase() === 'funded')
//         .map((item) => ({
//           id: item[`${activeToggle.toLowerCase()}_participant`]?.id,
//           ideaId: item.idea_submission?.id,
//           name:
//             activeToggle === 'Single'
//               ? `Participant ${item.single_participant.student_id}`
//               : item.group_participant.name_of_group,
//           projectType:
//             item[`${activeToggle.toLowerCase()}_participant`]?.project_type || 'N/A',
//           numberOfMembers: item.group_participant?.number_of_member || null,
//           projectTitle: item.idea_submission.title || 'N/A',
//           ideaFile: item.idea_submission.idea_file || '',
//         }));

//       setData(fundedData);
//     } catch (error) {
//       console.error('Error fetching funded participants:', error);
//     }
//   };

//   const handleChangePage = (event, newPage) => setPage(newPage);

//   const filteredData = data.filter((row) =>
//     row.projectTitle.toLowerCase().includes(searchTerm)
//   );

//   const paginatedData = filteredData.slice(
//     (page - 1) * ITEMS_PER_PAGE,
//     page * ITEMS_PER_PAGE
//   );

//   return (
//     <Box sx={{ p: 4 }}>
//       <Typography variant="h6">
//         {activeToggle === 'Group' ? 'Funded Projects (Group)' : 'Funded Projects (Single)'}
//       </Typography>

//       {/* Toggle and Search */}
//       <Box sx={{ display: 'flex', justifyContent: 'space-between', my: 2 }}>
//         <Box>
//           <Button
//             variant={activeToggle === 'Group' ? 'contained' : 'outlined'}
//             onClick={() => setActiveToggle('Group')}
//           >
//             Group
//           </Button>
//           <Button
//             variant={activeToggle === 'Single' ? 'contained' : 'outlined'}
//             onClick={() => setActiveToggle('Single')}
//             sx={{ ml: 1 }}
//           >
//             Single
//           </Button>
//         </Box>

//         <TextField
//           placeholder="Search by Project Title"
//           size="small"
//           value={searchTerm}
//           onChange={(e) => setSearchTerm(e.target.value.toLowerCase())}
//           sx={{ width: '300px' }}
//         />
//       </Box>

//       {/* Table */}
//       <TableContainer component={Paper} sx={{ borderRadius: 2 }}>
//         <Table>
//           <TableHead>
//             <TableRow>
//               <StyledTableCell>Sr. No.</StyledTableCell>
//               <StyledTableCell>{activeToggle === 'Group' ? 'Group Name' : 'Name'}</StyledTableCell>
//               <StyledTableCell>Project Type</StyledTableCell>
//               {activeToggle === 'Group' && <StyledTableCell>Members</StyledTableCell>}
//               <StyledTableCell>Project Title</StyledTableCell>
//               <StyledTableCell>Uploaded File</StyledTableCell>
//             </TableRow>
//           </TableHead>
//           <TableBody>
//             {paginatedData.map((row, index) => (
//               <TableRow key={row.id}>
//                 <StyledTableCell>{(page - 1) * ITEMS_PER_PAGE + index + 1}</StyledTableCell>
//                 <StyledTableCell>{row.name}</StyledTableCell>
//                 <StyledTableCell>{row.projectType}</StyledTableCell>
//                 {activeToggle === 'Group' && <StyledTableCell>{row.numberOfMembers}</StyledTableCell>}
//                 <StyledTableCell>{row.projectTitle}</StyledTableCell>
//                 <StyledTableCell>
//                   {row.ideaFile ? (
//                     <IconButton
//                       size="small"
//                       href={`https://puneexpobackend.tdtlworld.com/${row.ideaFile}`}
//                       target="_blank"
//                       rel="noopener noreferrer"
//                     >
//                       <CloudDownloadIcon />
//                     </IconButton>
//                   ) : (
//                     'No file'
//                   )}
//                 </StyledTableCell>
//               </TableRow>
//             ))}
//           </TableBody>
//         </Table>
//       </TableContainer>

//       {/* Pagination */}
//       {filteredData.length > ITEMS_PER_PAGE && (
//         <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
//           <Pagination
//             count={Math.ceil(filteredData.length / ITEMS_PER_PAGE)}
//             page={page}
//             onChange={handleChangePage}
//             shape="rounded"
//           />
//         </Box>
//       )}
//     </Box>
//   );
// };

// export default MyInvestments;

// import React, { useState, useEffect } from 'react';
// import {
//   Box,
//   Typography,
//   Button,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   IconButton,
//   Pagination,
//   TextField,
//   Card,
//   CardContent,
//   CardHeader,
// } from '@mui/material';
// import { styled } from '@mui/material/styles';
// import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
// import GroupIcon from '@mui/icons-material/Group';
// import PersonIcon from '@mui/icons-material/Person';
// import SearchIcon from '@mui/icons-material/Search';
// import axios from 'axios';

// const StyledTableCell = styled(TableCell)({
//   padding: '16px',
//   fontSize: '0.875rem',
//   color: '#4A4A4A',
// });

// const ITEMS_PER_PAGE = 5;

// const MyInvestments = () => {
//   const [activeToggle, setActiveToggle] = useState('Group');
//   const [page, setPage] = useState(1);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [data, setData] = useState([]);

//   useEffect(() => {
//     fetchFundedParticipants();
//   }, [activeToggle]);

//   const fetchFundedParticipants = async () => {
//     try {
//       const endpoint =
//         activeToggle === 'Single'
//           ? 'https://puneexpobackend.tdtlworld.com/api/all_single_participants/'
//           : 'https://puneexpobackend.tdtlworld.com/api/all_group_participants/';

//       const response = await axios.get(endpoint);

//       const fundedData = response.data.data
//         .filter((item) => item.idea_submission?.status?.toLowerCase() === 'funded')
//         .map((item) => ({
//           id: item[`${activeToggle.toLowerCase()}_participant`]?.id,
//           ideaId: item.idea_submission?.id,
//           name:
//             activeToggle === 'Single'
//               ? `Participant ${item.single_participant.student_id}`
//               : item.group_participant.name_of_group,
//           projectType:
//             item[`${activeToggle.toLowerCase()}_participant`]?.project_type || 'N/A',
//           numberOfMembers: item.group_participant?.number_of_member || null,
//           projectTitle: item.idea_submission.title || 'N/A',
//           ideaFile: item.idea_submission.idea_file || '',
//         }));

//       setData(fundedData);
//     } catch (error) {
//       console.error('Error fetching funded participants:', error);
//     }
//   };

//   const handleChangePage = (event, newPage) => setPage(newPage);

//   const filteredData = data.filter((row) =>
//     row.projectTitle.toLowerCase().includes(searchTerm)
//   );

//   const paginatedData = filteredData.slice(
//     (page - 1) * ITEMS_PER_PAGE,
//     page * ITEMS_PER_PAGE
//   );

//   return (
//     <Box sx={{ p: 4, background: 'linear-gradient(135deg, #D6F8F8, #E9D8FD)', minHeight: '100vh' }}>
//       <Card elevation={3} sx={{ mb: 3, borderRadius: 4, backgroundColor: '#fff', color: '#fff',mt:8 }}>
//         <CardHeader
//           title={<Typography variant="h5" sx={{ fontWeight: 'bold', color: '#000' }}>My Investments</Typography>}
//           subheader="View Your Funded Projects"
//           sx={{ py: 2, borderBottom: '1px solid #fff' }}
//         />
//       </Card>

//       <Card elevation={2} sx={{ mb: 3, borderRadius: 4, backgroundColor: '#fff' }}>
//         <CardContent>
//           <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//             <Box>
//               <Button
//                 variant={activeToggle === 'Group' ? 'contained' : 'outlined'}
//                 onClick={() => setActiveToggle('Group')}
//                 startIcon={<GroupIcon />}
//                 sx={{
//                   mr: 1,
//                   backgroundColor: activeToggle === 'Group' ? '#1EA0D833' : 'transparent',
//                   color: activeToggle === 'Group' ? '#fff' : '#673AB7',
//                   '&:hover': { backgroundColor: '#FF8DA8' },
//                 }}
//               >
//                 Group
//               </Button>
//               <Button
//                 variant={activeToggle === 'Single' ? 'contained' : 'outlined'}
//                 onClick={() => setActiveToggle('Single')}
//                 startIcon={<PersonIcon />}
//                 sx={{
//                   backgroundColor: activeToggle === 'Single' ? '#1EA0D833' : 'transparent',
//                   color: activeToggle === 'Single' ? '#fff' : '#673AB7',
//                   '&:hover': { backgroundColor: '#FF8DA8' },
//                 }}
//               >
//                 Single
//               </Button>
//             </Box>

//             <TextField
//               placeholder="Search by Project Title"
//               size="small"
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value.toLowerCase())}
//               InputProps={{
//                 startAdornment: <SearchIcon sx={{ mr: 1, color: '#673AB7' }} />,
//               }}
//               sx={{ width: '300px', borderColor: '#1EA0D833', backgroundColor: '#F8F9FA', borderRadius: 2 }}
//             />
//           </Box>
//         </CardContent>
//       </Card>

//       <Card elevation={3} sx={{ borderRadius: 4, backgroundColor: '#FDF8FF' }}>
//         <TableContainer>
//           <Table>
//             <TableHead>
//               <TableRow sx={{ backgroundColor: '#1EA0D833' }}>
//                 <StyledTableCell sx={{ color: '#000' }}>Sr. No.</StyledTableCell>
//                 <StyledTableCell sx={{ color: '#000' }}>{activeToggle === 'Group' ? 'Group Name' : 'Name'}</StyledTableCell>
//                 <StyledTableCell sx={{ color: '#000' }}>Project Type</StyledTableCell>
//                 {activeToggle === 'Group' && <StyledTableCell sx={{ color: '#000' }}>Members</StyledTableCell>}
//                 <StyledTableCell sx={{ color: '#000' }}>Project Title</StyledTableCell>
//                 <StyledTableCell sx={{ color: '#000' }}>Uploaded File</StyledTableCell>
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {paginatedData.map((row, index) => (
//                 <TableRow key={row.id} sx={{ '&:hover': { backgroundColor: '#FCE4EC' } }}>
//                   <StyledTableCell>{(page - 1) * ITEMS_PER_PAGE + index + 1}</StyledTableCell>
//                   <StyledTableCell>{row.name}</StyledTableCell>
//                   <StyledTableCell>{row.projectType}</StyledTableCell>
//                   {activeToggle === 'Group' && <StyledTableCell>{row.numberOfMembers}</StyledTableCell>}
//                   <StyledTableCell>{row.projectTitle}</StyledTableCell>
//                   <StyledTableCell>
//                     {row.ideaFile ? (
//                       <IconButton
//                         size="small"
//                         href={`${row.ideaFile}`}
//                         target="_blank"
//                         rel="noopener noreferrer"
//                       >
//                         <CloudDownloadIcon sx={{ color: '#1EA0D833' }} />
//                       </IconButton>
//                     ) : (
//                       'No file'
//                     )}
//                   </StyledTableCell>
//                 </TableRow>
//               ))}
//             </TableBody>
//           </Table>
//         </TableContainer>

//         {filteredData.length > ITEMS_PER_PAGE && (
//           <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
//             <Pagination
//               count={Math.ceil(filteredData.length / ITEMS_PER_PAGE)}
//               page={page}
//               onChange={handleChangePage}
//               shape="rounded"
//               sx={{ '.MuiPaginationItem-root': { color: '#673AB7' } }}
//             />
//           </Box>
//         )}
//       </Card>
//     </Box>
//   );
// };

// export default MyInvestments;
import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Pagination,
  TextField,
  Card,
  CardContent,
  CardHeader,
  IconButton,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import GroupIcon from '@mui/icons-material/Group';
import PersonIcon from '@mui/icons-material/Person';
import SearchIcon from '@mui/icons-material/Search';
import axios from 'axios';
import swal from 'sweetalert';
 
const StyledTableCell = styled(TableCell)({
  padding: '16px',
  fontSize: '0.875rem',
  color: '#4A4A4A',
});
 
const ITEMS_PER_PAGE = 5;
 
const MyInvestments = () => {
  const [activeToggle, setActiveToggle] = useState('Group');
  const [page, setPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [data, setData] = useState([]);
 
  useEffect(() => {
    fetchFundedParticipants();
  }, [activeToggle]);
 
  const fetchFundedParticipants = async () => {
    try {
      swal({
        title: 'Loading...',
        text: 'Fetching your investments, please wait.',
        icon: 'info',
        buttons: false,
        closeOnClickOutside: false,
      });
 
      const endpoint =
        activeToggle === 'Single'
          ? 'https://puneexpobackend.tdtlworld.com/api/all_single_participants/'
          : 'https://puneexpobackend.tdtlworld.com/api/all_group_participants/';
 
      const response = await axios.get(endpoint);
 
      const fundedData = response.data.data
        .filter((item) => item.idea_submission?.status?.toLowerCase() === 'funded')
        .map((item) => ({
          id: item[`${activeToggle.toLowerCase()}_participant`]?.id,
          ideaId: item.idea_submission?.id,
          name:
            activeToggle === 'Single'
              ? `Participant ${item.single_participant.student_id}`
              : item.group_participant.name_of_group,
          projectType:
            item[`${activeToggle.toLowerCase()}_participant`]?.project_type || 'N/A',
          numberOfMembers: item.group_participant?.number_of_member || null,
          projectTitle: item.idea_submission.title || 'N/A',
          ideaFile: item.idea_submission.idea_file || '',
        }));
 
      swal.close();
      setData(fundedData);
    } catch (error) {
      swal('Error', 'Failed to fetch your investments. Please try again.', 'error');
      console.error('Error fetching funded participants:', error);
    }
  };
 
  const handleChangePage = (event, newPage) => setPage(newPage);
 
  const filteredData = data.filter((row) =>
    row.projectTitle.toLowerCase().includes(searchTerm)
  );
 
  const paginatedData = filteredData.slice(
    (page - 1) * ITEMS_PER_PAGE,
    page * ITEMS_PER_PAGE
  );
 
  return (
    <Box sx={{ p: 4, background: 'linear-gradient(135deg, #E8F5E9, #E3F2FD)', minHeight: '100vh' }}>
      <Card elevation={3} sx={{ mb: 3, borderRadius: 4, backgroundColor: '#FAFAFA', color: '#000', mt: 8 }}>
        <CardHeader
          title={<Typography variant="h5" sx={{ fontWeight: 'bold', color: '#2C3E50' }}>My Investments</Typography>}
          subheader="View projects you have funded"
          sx={{ py: 2, borderBottom: '1px solid #E0E0E0' }}
        />
        <CardContent>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Box>
              <Button
                variant={activeToggle === 'Group' ? 'contained' : 'outlined'}
                onClick={() => setActiveToggle('Group')}
                startIcon={<GroupIcon />}
                sx={{
                  mr: 1,
                  backgroundColor: activeToggle === 'Group' ? '#424242' : 'transparent',
                  color: activeToggle === 'Group' ? '#fff' : '#2C3E50',
                  '&:hover': { backgroundColor: '#616161' },
                }}
              >
                Group
              </Button>
              <Button
                variant={activeToggle === 'Single' ? 'contained' : 'outlined'}
                onClick={() => setActiveToggle('Single')}
                startIcon={<PersonIcon />}
                sx={{
                  backgroundColor: activeToggle === 'Single' ? '#424242' : 'transparent',
                  color: activeToggle === 'Single' ? '#fff' : '#2C3E50',
                  '&:hover': { backgroundColor: '#616161' },
                }}
              >
                Single
              </Button>
            </Box>
 
            <TextField
              placeholder="Search by Project Title"
              size="small"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value.toLowerCase())}
              InputProps={{
                startAdornment: <SearchIcon sx={{ mr: 1, color: '#2C3E50' }} />,
              }}
              sx={{ width: '300px', backgroundColor: '#F5F5F5', borderRadius: 2 }}
            />
          </Box>
        </CardContent>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow sx={{ backgroundColor: '#B0BEC5' }}>
                <StyledTableCell>Sr. No.</StyledTableCell>
                <StyledTableCell>{activeToggle === 'Group' ? 'Group Name' : 'Name'}</StyledTableCell>
                <StyledTableCell>Project Type</StyledTableCell>
                {activeToggle === 'Group' && <StyledTableCell>Members</StyledTableCell>}
                <StyledTableCell>Project Title</StyledTableCell>
                <StyledTableCell>Uploaded File</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedData.map((row, index) => (
                <TableRow key={row.id} sx={{ '&:hover': { backgroundColor: '#ECEFF1' } }}>
                  <StyledTableCell>{(page - 1) * ITEMS_PER_PAGE + index + 1}</StyledTableCell>
                  <StyledTableCell>{row.name}</StyledTableCell>
                  <StyledTableCell>{row.projectType}</StyledTableCell>
                  {activeToggle === 'Group' && <StyledTableCell>{row.numberOfMembers}</StyledTableCell>}
                  <StyledTableCell>{row.projectTitle}</StyledTableCell>
                  <StyledTableCell>
                    {row.ideaFile ? (
                      <IconButton
                        size="small"
                        href={row.ideaFile}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <CloudDownloadIcon sx={{ color: '#424242' }} />
                      </IconButton>
                    ) : (
                      'No file'
                    )}
                  </StyledTableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
 
        <Pagination
          count={Math.ceil(filteredData.length / ITEMS_PER_PAGE)}
          page={page}
          onChange={handleChangePage}
          sx={{ mt: 3 }}
        />
      </Card>
 
     
    </Box>
  );
};
 
export default MyInvestments;